// extracted by mini-css-extract-plugin
module.exports = {"container":"MatchStats_container__iY57p","title":"MatchStats_title__B1sbf","list":"MatchStats_list__29Ej7"};